<div class="content-overlay">
  <div class="entity-browse__header">
    <span class="entity-browse__header__info">
      Vybráno:
      <strong>{{ chosen.length }}</strong>
    </span>
    <a (click)="submitEntities()" class="cta cta--small cta--green">
      <i class="ico-success"></i> Potvrdit
      <span class="cta--light">výběr</span>
    </a>
    <a (click)="close()" class="cta cta--small cta--red">
      <i class="ico-remove"></i> Zavřít</a>
    <div class="entity-browse__header__filter">
      <swb-filter-list (modelChange)="filter($event)" [bgColor]="'white'"></swb-filter-list>
    </div>
  </div>
  <div class="entity-browse__wrap">
    <pagination-controls *ngIf="pagination.pageSize > 0" id="browse-entities" (pageChange)="pageChanged($event)" maxSize="9"
      directionLinks="true" autoHide="true" previousLabel="" nextLabel="" screenReaderPaginationLabel="Pagination" screenReaderPageLabel="Stránka"
      screenReaderCurrentLabel="Jste na stránce">
    </pagination-controls>
    <div id="entity-list" class="paginated-content media__list">
      <div *ngFor="let entity of entities | paginate: { id: 'browse-entities', itemsPerPage: pagination.pageSize, currentPage:
    p, totalItems: pagination.total }" class="media__list__item">
        <a (click)="chooseEntity(entity);" [ngClass]="{'media__list__item__box--chosen': chosen.includes(entity)}" class="media__list__item__box media__list__item__box--choosable"
          [ngStyle]="getBoxStyle(entity.file)">
          <div class="media__list__item__filename" *ngIf="!entity.file || !entity.file.is_image">
            <span class="media__list__item__filename__inside">{{ (isString(entity.title) ? entity.title : getTitle(entity)) }}</span>
          </div>
          <div class="media__list__item__actions">
            <div class="media__list__item__actions__title">{{ (isString(entity.title) ? entity.title : getTitle(entity)) }}</div>
            <br>
            <span class="media__list__item__actions__link media__list__item__actions__link--view" title="Vybrat soubor.">
              <i class="ico-success"></i>
            </span>
          </div>
        </a>
      </div>
    </div>
    <pagination-controls *ngIf="pagination.pageSize > 0" id="browse-entities" (pageChange)="pageChanged($event)" maxSize="9"
      directionLinks="true" autoHide="true" previousLabel="" nextLabel="" screenReaderPaginationLabel="Pagination" screenReaderPageLabel="Stránka"
      screenReaderCurrentLabel="Jste na stránce">
    </pagination-controls>

    <swb-no-data *ngIf="entities && entities.length === 0"></swb-no-data>
  </div>
</div>
